document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.vybe-card__swatch');
  if (!swatch) return;

  const card = swatch.closest('[data-vybe-card]');
  if (!card) return;

  for (const other of card.querySelectorAll('.vybe-card__swatch')) {
    other.classList.toggle('is-selected', other === swatch);
  }

  const { variantId, price, compare, off, mediaId, available } = swatch.dataset;

  const input = card.querySelector('[data-vybe-variant-input]');
  if (input && variantId) input.value = variantId;

  const priceEl = card.querySelector('[data-vybe-price]');
  if (priceEl && price) priceEl.textContent = price;

  const compareEl = card.querySelector('[data-vybe-compare]');
  if (compareEl) {
    compareEl.textContent = compare || '';
    compareEl.hidden = !compare;
  }

  const offEl = card.querySelector('[data-vybe-off]');
  if (offEl) {
    offEl.textContent = off || '';
    offEl.hidden = !off;
  }

  const button = card.querySelector('[data-vybe-atc]');
  if (button) {
    const inStock = available === 'true';
    button.disabled = !inStock;
    button.textContent = inStock ? button.dataset.labelAvailable : button.dataset.labelSoldOut;
  }

  const track = card.querySelector('.vybe-card__swipe');
  const slide = mediaId && card.querySelector(`.vybe-card__slide[data-media-id="${CSS.escape(mediaId)}"]`);
  if (track && slide) {
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
});
